// extracted by mini-css-extract-plugin
export var circle = "_26-2";
export var icon = "_26-a";
export var iconHighlight = "_26-0";
export var lg = "_26-8";
export var md = "_26-7";
export var outline = "_26-4";
export var sm = "_26-6";
export var square = "_26-1";
export var xl = "_26-9";
export var xs = "_26-5";
export var xxs = "_26-3";